import useScreenOrientation from "react-hook-screen-orientation";
import {useMemo} from "react";

export const ORIENTATION_PORTRAIT = 'portrait';
export const ORIENTATION_LANDSCAPE = 'landscape';
export const ORIENTATION_PORTRAIT_PRIMARY = `${ORIENTATION_PORTRAIT}-primary`;
export const ORIENTATION_PORTRAIT_SECONDARY = `${ORIENTATION_PORTRAIT}-secondary`;
export const ORIENTATION_LANDSCAPE_PRIMARY = `${ORIENTATION_LANDSCAPE}-primary`;
export const ORIENTATION_LANDSCAPE_SECONDARY = `${ORIENTATION_LANDSCAPE}-secondary`;

export const isPortraitCheck = orientation => [ORIENTATION_PORTRAIT_PRIMARY, ORIENTATION_PORTRAIT_SECONDARY]
  .some(el => el === orientation);

export const isLandscapeCheck = orientation => [ORIENTATION_LANDSCAPE_PRIMARY, ORIENTATION_LANDSCAPE_SECONDARY]
  .some(el => el === orientation);

export default function useScreenOrientationExtended() {
  const screenOrientation = useScreenOrientation();
  
  const isPortrait = isPortraitCheck(screenOrientation);
  const isLandscape = isLandscapeCheck(screenOrientation);
  
  const className = useMemo(() => {
    return (isPortrait && ORIENTATION_PORTRAIT) || (isLandscape && ORIENTATION_LANDSCAPE);
  }, [isPortrait, isLandscape]);
  
  return {
    isPortrait,
    isLandscape,
    className,
  }
}